import React from 'react'
import { Link } from 'react-router-dom';

function LeatestProduct(props) {
    const data = props.data
    const limitedItems = data.slice(0, 6);

    return (
        <div>
            <div className="row">
                <div className="col-12 mb-4">
                    <h1 className='display-6 fw-bolder text-center mt-5'>LEATEST ARRIVALS</h1>
                    <hr />
                </div>
            </div>

            <div className='row'>
                {limitedItems.map((products) => {

                    return (
                        <>


                            <div className="col col-sm-6 col-md-4 col-lg-3 col-xl-2  mb-4" key={products._id} >
                                <div className="card h-60  text-center p-2" key={products._id}>
                                    <img src={products.image} className="card-img-top" alt={products.title} height='200px' />
                                    <div className="card-body">
                                        <h5 className="card-title mb-0">{products.title.substring(0, 12)}</h5>
                                        <p className="card-text fw-bolder">₹{products.price}</p>
                                        <Link to={`/productDet/${products.id}`} className="btn btn-outline-dark m-0 ">BUY</Link>
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                })}
            </div>
            <hr className='mb-5' />
        </div>
    )
}

export default LeatestProduct